export const appsData = [
  { id: 'apalfred', url: 'https://apalfred.com', icon: 'FiBook', categories: ['apa'] },
  { id: 'plapi', url: 'https://plapi.com.co', icon: 'FiShield', categories: ['plagio', 'prop'] },
  { id: 'innovaprompt', url: 'https://innovaprompt.com', icon: 'FiZap', categories: ['instr', 'ia', 'prompts'] },
  { id: 'lingualfred', url: 'https://lingualfred.com', icon: 'FiGlobe', categories: ['lang'] },
  { id: 'colombia', url: 'https://repositorios.com.co', icon: 'FiDatabase', categories: ['repo'] },
  { id: 'recursosia', url: 'https://recursosdeia.com.co', icon: 'FiCpu', categories: ['ia'] }
];